import * as React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { Divider } from "@/components/ui/divider";
import { cn } from "@/utils/utils";
import { Add } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";

interface AddButtonFooterProps extends Omit<ButtonProps, "children"> {
  buttonText: string;
  buttonClassName?: string;
  dividerClassName?: string;
  fullWidth?: boolean;
}

const AddButtonFooter: React.FC<AddButtonFooterProps> = ({
  buttonText,
  buttonClassName,
  dividerClassName,
  className,
  variant = "tertiary",
  fullWidth = true,
  disabled,
  ...buttonProps
}) => {
  return (
    <div className={cn(className)}>
      <Divider className={cn("py-[2px]", dividerClassName)} />
      <Button
        variant={variant}
        className={cn(
          "h-9  justify-start px-3 py-2",
          "bg-surface-elevation3 dark:text-cta hover:!text-cta",
          disabled && "opacity-50 cursor-not-allowed",
          !disabled && "hover:!text-cta",
          fullWidth ? "w-full" : "w-fit",
          buttonClassName
        )}
        disabled={disabled}
        {...buttonProps}
      >
        <IconContainer size="5" color="inherit">
          <Add />
        </IconContainer>
        {buttonText}
      </Button>
    </div>
  );
};

AddButtonFooter.displayName = "AddButtonFooter";

export { AddButtonFooter };
export type { AddButtonFooterProps };
